import { MAX_SAFE_SIGNIFICANT_DIGITS } from '../constants';

const cache = new Map<number, Intl.NumberFormat>();

export const formatFloat = (
  value: number,
  minimumFractionDigits = 0
): string => {
  // Intl throws if minimumFractionDigits exceeds maximumFractionDigits
  const safeMin = Math.min(minimumFractionDigits, MAX_SAFE_SIGNIFICANT_DIGITS);
  if (!cache.has(safeMin)) {
    cache.set(
      safeMin,
      new Intl.NumberFormat('cs-CZ', {
        useGrouping: true,
        minimumFractionDigits: safeMin,
        maximumFractionDigits: MAX_SAFE_SIGNIFICANT_DIGITS,
      })
    );
  }
  return cache.get(safeMin)!.format(value);
};
